import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";
import { Typo } from "@pepperstone/pepper-ui-kit";
import { Link } from "@tanstack/react-router";

export const TopEarnersTableSkeleton = ({
  title,
  goToEarningsLinkLabel,
  isBackoffice = false,
}: {
  title?: string;
  goToEarningsLinkLabel?: string;
  isBackoffice?: boolean;
}) => {
  return (
    <div className="w-full" data-testid="top-earners-skeleton">
      <div className="mx-auto rounded-2xl border border-stroke-primary bg-surface-base-background shadow-sm">
        <div className="flex items-center justify-between border-b border-stroke-primary p-6">
          <Typo
            elem="h1"
            type="label"
            size="lg"
            textColor="ps-text-text-primary-base"
          >
            {title}
          </Typo>
          <button className="font-semibold">
            {!isBackoffice ? (
              <Link key="/earnings" to={"/earnings" as never}>
                {goToEarningsLinkLabel}
              </Link>
            ) : null}
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-stroke-primary">
                <th className="px-6 py-4 text-left">
                  <SkeletonLoader
                    variant="rectangular"
                    height={20}
                    width={250}
                  />
                </th>
                <th className="px-6 py-4 text-right">
                  <SkeletonLoader
                    variant="rectangular"
                    height={20}
                    width={150}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 4 }).map((_, index) => (
                <tr key={index} className="border-b border-stroke-primary">
                  <td className="px-6 py-4">
                    <SkeletonLoader
                      variant="rectangular"
                      height={20}
                      width={300}
                    />
                  </td>
                  <td className="px-6 py-4 text-right">
                    <SkeletonLoader
                      variant="rectangular"
                      height={20}
                      width={150}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
